import React from "react";
import { toast } from "react-toastify";
import { ADD_HABITACION, REMOVE_HABITACION } from "../../../../../context/constantes";
import { calcularTotalCapacidad } from "../../../../../utils/Tools";

const Habitaciones = (props) => {
    const { habitaciones = [], dispatch, isResultados, pasajerosAdultos, tiposDeHabitacion = [] } = props;

    const handleClickMasHabitacion = (e) => {

      const habitacionElegida = tiposDeHabitacion.find(tip => tip.idTipoHabitacion === e.target.value);

      if (habitacionElegida) {
        if (calcularTotalCapacidad(habitaciones.concat([habitacionElegida])) > pasajerosAdultos.length) {
          toast.info("No puede agregar mas habitaciones", {
            position: toast.POSITION.BOTTOM_CENTER
            });
            return;
        }

        dispatch({type: ADD_HABITACION, payload: habitacionElegida });

      }

        e.target.value = 0;
    };
    
    const handleClickMenosHabitacion = () => {
        dispatch({type: REMOVE_HABITACION});
    };

    const dibujarTiposDeHabitacion = (tipos = []) => {
      return tipos.map((tipo, i) => <option key={i} value={tipo.idTipoHabitacion}>{tipo.nombreTipo}</option>)
    };

    const validarCantidadPax = (habit,  cantidadPax) => {
      return cantidadPax > calcularTotalCapacidad(habit) ;
    };
    

    return (
        <div className="divHabitacionesPaquetes">
          {habitaciones.map((hab, i) => {
            return (
              <div
                className="row habitaciones"
                key={i}
              >
                <div style={{ width: "100%" }}
                    className="d-block">
                  <label style={{display: 'inline-block'}}>
                    Habitaci&oacute;n {i + 1} - {hab && hab.nombreTipo}
                  </label>
                  { habitaciones.length - 1 === i && (
                    <span style={{color: 'rgb(24 30 52)', cursor: 'pointer'}} onClick={handleClickMenosHabitacion}>
                      Modificar
                    </span>
                  )}
                </div>
              </div>
            );
          })}
          {validarCantidadPax(habitaciones, pasajerosAdultos.length) && (
            <div className="btnAgregarHab" style={{color: isResultados ? '#fff' : '#000'}}>
              <span>
                Agregar Habitación:
              </span>
              <select
                  onChange={handleClickMasHabitacion}
                >
                  <option value="0">Seleccionar Tipo de Habitacion</option>
                  {dibujarTiposDeHabitacion(tiposDeHabitacion)}
                </select>
          </div>
          )}
        </div>
      )
}

export default Habitaciones;


// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/CharterFila/habitaciones.js